import React, { useState } from "react";
import "./SignIn.css";
import { signup } from "../../../../../Functions/API/services/authService";

const SignUpForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    confirmPassword: "",
    role: "Student",
    nationality: "international",
    classOf: "",
  });

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

 

    const userPayload = {
      username: `${formData.firstName} ${formData.lastName}`,
      email: formData.email,
      role: formData.role,
      nationality: formData.nationality,
      ClassOf: formData.classOf,
    };

    setFormData({
    firstName: "",
    lastName: "",
    email: "",
    confirmPassword: "",
    role: "Student",
    nationality: "international",
    classOf: "",
  })
    try {
      setLoading(true);

      const data = await signup(userPayload);

      if (!data) throw new Error(data.message || "Sign up failed");

      alert("Account created successfully 🎉");
      console.log("User:", data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signup-container">
      <form className="signup-form" onSubmit={handleSubmit}>
        <h2>Create an Account</h2>

        {error && <p className="error">{error==="Request failed with status code 400"?"This email is already in use.":null}</p>}

        <div className="form-row">
          <div className="form-group">
            <label>First Name *</label>
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Last Name *</label>
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-group">
          <label>Email *</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Role *</label>
            <select name="role" value={formData.role} onChange={handleChange}>
              <option value="Student">Student</option>
              <option value="Moderator">Moderator</option>
              <option value="Coordinator">Coordinator</option>
              <option value="Admin">Admin</option>
            </select>
          </div>

          <div className="form-group">
            <label>Nationality *</label>
            <select
              name="nationality"
              value={formData.nationality}
              onChange={handleChange}
            >
              <option value="international">International</option>
              <option value="tunisian">Tunisian</option>
            </select>
          </div>
        </div>

        <div className="form-group">
          <label>Class Of (Year) *</label>
          <select
            name="classOf"
            value={formData.classOf}
            onChange={handleChange}
            required
          >
            <option value="">Select Year</option>
            <option value="2024">2024</option>
            <option value="2025">2025</option>
            <option value="2026">2026</option>
            <option value="2027">2027</option>
            <option value="2028">2028</option>
            <option value="2029">2029</option>
            <option value="2030">2030</option>
          </select>
        </div>

        <button type="submit" disabled={loading}>
          {loading ? "Creating account..." : "Create Account"}
        </button>
      </form>
    </div>
  );
};

export default SignUpForm;
